const TMA_HOSTS = new Set([
  'app.shot.band',
  'app.cs-shot.pro',
  'app.cs-shot.uz',
  'app-dev1.shot.band',
  'app-dev1.cs-shot.pro',
  'ultrathink.cs-shot.pro',
]);

export function isTmaHost(host: string): boolean {
  if (!host) return false;
  const colonIdx = host.indexOf(':');
  const hostname = colonIdx >= 0 ? host.slice(0, colonIdx) : host;
  return TMA_HOSTS.has(hostname);
}

const PROD_ORIGIN = 'https://shot.band';
const DEV_ORIGIN = 'https://dev1.shot.band';

const CANONICAL_ORIGIN_BY_HOST: Record<string, string> = {
  'shot.band': PROD_ORIGIN,
  'cs-shot.pro': PROD_ORIGIN,
  'cs-shot.uz': PROD_ORIGIN,
  'dev1.shot.band': DEV_ORIGIN,
  'dev1.cs-shot.pro': DEV_ORIGIN,
};

export function canonicalOrigin(host: string | null): string | null {
  if (!host) return null;
  const colonIdx = host.indexOf(':');
  const hostname = colonIdx >= 0 ? host.slice(0, colonIdx) : host;
  return CANONICAL_ORIGIN_BY_HOST[hostname] ?? null;
}

export const canonicalOriginOrDefault = (host: string | null): string => canonicalOrigin(host) ?? PROD_ORIGIN;

const INDEXABLE_HOSTS = new Set(['shot.band', 'cs-shot.uz']);

export function isIndexableHost(host: string | null): boolean {
  if (!host) return false;
  const colonIdx = host.indexOf(':');
  const hostname = colonIdx >= 0 ? host.slice(0, colonIdx) : host;
  return INDEXABLE_HOSTS.has(hostname);
}

export function isCsShotUzHost(host: string): boolean {
  if (!host) return false;
  const colonIdx = host.indexOf(':');
  const hostname = colonIdx >= 0 ? host.slice(0, colonIdx) : host;
  return hostname === 'cs-shot.uz' || hostname.endsWith('.cs-shot.uz');
}

export type Runtime = 'tma' | 'web';
